import React from 'react';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ReportingLinesEmptyState } from './ReportingLines/EmptyState';
import { ReportingLinesErrorState } from './ReportingLines/ErrorState';
import { type ReportingLinesResponse } from './ReportingLines/hooks';
import { ReportingLinesChartFromResponse } from './ReportingLines/ReportingLinesChart';
import { responseHasReportingLinesData } from './utils';

export type ReportingLinesProps = {
	reportingLinesResponse: ReportingLinesResponse;
};

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: token('space.100', '8px'),
		paddingRight: token('space.100', '8px'),
		paddingBottom: token('space.100', '8px'),
		paddingLeft: token('space.100', '8px'),
		borderRadius: token('radius.small'),
	},
});

const ChartContainer = Box;

export const ReportingLines = (props: ReportingLinesProps): React.JSX.Element => {
	const { reportingLinesResponse } = props;

	const hasReportingLinesData = responseHasReportingLinesData(reportingLinesResponse);
	const { isLoading, error } = reportingLinesResponse;

	if (error && !isLoading && fg('teams_app_user_profile_refresh')) {
		return <ReportingLinesErrorState />;
	}

	if (!hasReportingLinesData && !(isLoading && fg('teams_app_user_profile_refresh'))) {
		return <ReportingLinesEmptyState />;
	}
	return (
		<ChartContainer xcss={styles.container}>
			<ReportingLinesChartFromResponse
				reportingLinesResponse={reportingLinesResponse}
				isResponseEmpty={!hasReportingLinesData}
			/>
		</ChartContainer>
	);
};

export default ReportingLines;
